// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"bc6f3d93","824":"f717f903"}[chunkId] + ".chunk.css";
};